import { SovosBox, SovosTypography } from "mosaic-react";
import React from "react";
import { PAGE_LAYOUT } from "./constants";

const ChooseEntityPageSection = ({ children, description, title }) => (
    <SovosBox
        sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, md: PAGE_LAYOUT.columnGap },
            mb: PAGE_LAYOUT.sectionGap,
            maxWidth: PAGE_LAYOUT.contentMaxWidth,
            width: "100%",
        }}
    >
        <SovosBox
            sx={{
                flexShrink: 0,
                maxWidth: { md: PAGE_LAYOUT.copyColumnWidth },
                width: { md: PAGE_LAYOUT.copyColumnWidth },
            }}
        >
            <SovosTypography fontWeight={600} sx={{ mb: 1 }} variant="h6">
                {title}
            </SovosTypography>
            <SovosTypography color="text.secondary" variant="body2">
                {description}
            </SovosTypography>
        </SovosBox>
        <SovosBox
            sx={{
                flex: 1,
                maxWidth: { md: PAGE_LAYOUT.fieldsColumnWidth },
                overflow: "visible",
                position: "relative",
                width: "100%",
            }}
        >
            {children}
        </SovosBox>
    </SovosBox>
);

export default ChooseEntityPageSection;
